import { createAction } from '@reduxjs/toolkit';

export const INTERACTION_ERROR = 'interactions/INTERACTION_ERROR';

export const interactionError =
  createAction<{ interaction: string; additionalInfo?: any }>(INTERACTION_ERROR);
